module Meevo.Components.Busy {

    export class MeevoGlobalBusy implements angular.IDirective {
        restrict = "E";
        templateUrl = 'app/components/busy/globalBusyTemplate.html';
        controller = GlobalBusyController;
        controllerAs = 'globalBusy';
        constructor() {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoGlobalBusy();
            };

            return directive;
        }
    }

    class GlobalBusyController {
        public highVisibility: boolean;
        public progressPercent: number = null;

        private isBusy: boolean = false;
        private messageKey: string;
        private defaultMessageKey: string = 'MESSAGE_PLEASE_WAIT';

        static $inject = ['$rootScope', '$scope'];
        constructor(private $rootScope: ng.IRootScopeService, $scope: ng.IScope) {

            // Subscribe to the global busy message
            this.$rootScope.$on(Meevo.Components.Common.Messages.GLOBAL_BUSY_START, (message, messageKey, highVisibility, withTimeout: boolean) => {
                if (withTimeout) {
                    $scope.$apply(() => {
                        this.show(messageKey, highVisibility);
                    });
                    return;
                }
                this.show(messageKey, highVisibility);
            });
            //
            this.$rootScope.$on(Meevo.Components.Common.Messages.GLOBAL_BUSY_STOP, (event: ng.IAngularEvent, withTimeout: boolean) => {
                if (withTimeout) {
                    $scope.$apply(() => {
                        this.hide();
                    });
                    return;
                }
                this.hide();
            });

            this.$rootScope.$on(Meevo.Components.Common.Messages.GLOBAL_BUSY_PROGRESS, (event: ng.IAngularEvent, percent: number) => {
                this.progressPercent = Math.floor(percent);
            });
        }

        private show(messageKey = this.defaultMessageKey, highVisibility?: boolean) {
            this.highVisibility = highVisibility;
            this.messageKey = messageKey;
            this.isBusy = true;
        }

        private hide() {
            this.isBusy = false;
            this.highVisibility = false;
            this.progressPercent = null;
        }
    }

    angular.module("meevo")
        .directive("meevoGlobalBusy", MeevoGlobalBusy.factory());
}
